<script>

    import { toast } from 'bulma-toast'
    import { createEventDispatcher } from 'svelte'
    import { CreditStore, InvoiceStore, UserStore } from '../stores'

    import InvoicesService from '../$services/invoices.service'

    import DateMethods from '../$methods/date.methods'
    import NumeralMethods from '../$methods/numeral.methods'
    import EnumMethods from '../$methods/enum.methods'

    import Button from '../$components/button.svelte'
    import Value from '../$components/value.svelte'

    let loading = false
    let element = null

    const dispatch = createEventDispatcher()

    async function getInvoiceDocument(type) {

        loading = true
        const blob = await InvoicesService.getInvoiceDocument($CreditStore.invoice.invoiceId, type)
        loading = false

        if(!blob)
            return toast({message: resp.error.message, type: 'is-danger'})

        element.download = `${$CreditStore.invoice.rfc}_${DateMethods.dateShort($CreditStore.invoice.created)}.${type}`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

</script>

{#if $CreditStore}
    <div class="columns">
        <div class="column">
            <Value label="Estatus" value={ EnumMethods.get($CreditStore.status) } />
        </div>
        <div class="column">
            <Value label="Método" value={ EnumMethods.get($CreditStore.method) } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Monto" value={ NumeralMethods.cash($CreditStore.amount) } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Referencia" value={ $CreditStore.reference } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Fecha" value={ DateMethods.dateTimeLarge($CreditStore.created) } />
        </div>
    </div>
    {#if $CreditStore.invoice}
        <div class="columns">
            <div class="column">
                <Value label="Factura en PDF" value="Descargar" icon="file-pdf" pointer={true} on:click={() => getInvoiceDocument('pdf')} />
            </div>
            <div class="column">
                <Value label="Factura en XML" value="Descargar" icon="file-code" pointer={true} on:click={() => getInvoiceDocument('xml')} />
            </div>
        </div>
    {/if}
    <hr>
    {#if !$CreditStore.invoice && $UserStore.facturamaId}
        <div class="items end">
            <Button on:click={() => InvoiceStore.modalCreate()} icon="plus" text="Solicitar factura" color="primary"  />
        </div>
    {/if}
    {#if !$UserStore.facturamaId}
        <div class="items space">
            <div><small>Para poder facturar necesitas ingresar tus datos de facturación</small></div>
            <div><a href="/#/informations/invoices">Ingresar datos de facturación</a></div>
        </div>
    {/if}
    <a href="/" bind:this={element} style="display: none;">#</a>
{/if}